import isLoggedWorkoutUtil from '../../../../modules/workout/model/utils/is-logged'
import getAllWorkoutsPlanSelector from '../get-all-workouts'
import { getIdReduxUtil } from '../../../redux/utils/get-id'

function getWorkoutLogsPlanSelector (plan) {
  return state => {
    const allWorkouts = getAllWorkoutsPlanSelector(plan)(state)
    // Used to avoid duplicates
    const workoutLoggedAlreadyFound = {}
    return allWorkouts.filter(workoutLog => {
      const id = getIdReduxUtil(workoutLog)
      if (workoutLoggedAlreadyFound[id]) {
        return false
      }
      if (isLoggedWorkoutUtil(workoutLog)) {
        workoutLoggedAlreadyFound[id] = true
        return true
      }
      return false
    })
  }
}

export default getWorkoutLogsPlanSelector
